<dx-data-grid biz-grid [selection]='{ mode: "single" }' [dataSource]='groups' [bizSetColumnChooser]="true"
    [bizSetGroupPanel]="false" [bizSetAllowColumnReordering]="false" (onInitNewRow)="onInitNewRow($event)"
    (onRowInserted)="onRowInserted($event)" (onRowUpdated)="onRowUpdated($event)"
    (onRowRemoving)="onRowRemoving($event)" [bizEditRowOnDoubleClick]="true">

    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="description" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="sortOrder" dataType="number">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="showType" dataType="number">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxo-lookup [dataSource]="showTypes" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(groups, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(groups, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog"></dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link [title]="'Log for ' + cell.data.name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="MonitorGroup" [id]="cell.data.id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>
</dx-data-grid>
